import { jsxs, jsx } from "react/jsx-runtime";
function SupportTicketsListPart({
  output
}) {
  if (!output || output.status !== "ok" || !output.tickets || output.tickets.length === 0) {
    return null;
  }
  const tickets = output.tickets.slice(0, 10);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "tw:my-2 tw:rounded-xl tw:border tw:border-gray-200 tw:bg-white tw:p-3 tw:shadow-sm",
      role: "group",
      "aria-label": "Your support tickets",
      children: [
        /* @__PURE__ */ jsxs("div", { className: "tw:mb-2 tw:flex tw:items-center tw:justify-between", children: [
          /* @__PURE__ */ jsx("span", { className: "tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wide tw:text-gray-500", children: "Your tickets" }),
          /* @__PURE__ */ jsx("span", { className: "tw:text-xs tw:text-gray-400", children: output.tickets.length })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "tw:flex tw:flex-col tw:divide-y tw:divide-gray-100", children: tickets.map((t) => {
          const ref = t.displayId ?? t.ticketId;
          const ticketUrl = t.ticketUrl;
          const title = t.title ?? t.summary ?? t.ticketTypeName ?? `Ticket #${ref}`;
          return /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:items-center tw:justify-between tw:py-2 tw:gap-3", children: [
            /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:flex-col tw:min-w-0", children: [
              /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:items-center tw:gap-2", children: [
                /* @__PURE__ */ jsxs("span", { className: "tw:text-sm tw:font-semibold tw:text-gray-900", children: [
                  "#",
                  ref
                ] }),
                /* @__PURE__ */ jsx(
                  "span",
                  {
                    className: `tw:rounded-full tw:px-2 tw:py-0.5 tw:text-[10px] tw:font-medium ${stateClass(t.state)}`,
                    style: isDefaultState(t.state) ? defaultStateStyle : void 0,
                    children: humanizeState(t.state)
                  }
                )
              ] }),
              /* @__PURE__ */ jsx("div", { className: "tw:truncate tw:text-xs tw:text-gray-500", children: title })
            ] }),
            ticketUrl && /* @__PURE__ */ jsx(
              "a",
              {
                href: ticketUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "tw:shrink-0 tw:rounded-md tw:border tw:border-gray-200 tw:bg-gray-50 tw:px-2 tw:py-1 tw:text-[11px] tw:font-semibold tw:text-gray-700 tw:no-underline hover:tw:bg-gray-100",
                children: "View"
              }
            )
          ] }, t.ticketId);
        }) })
      ]
    }
  );
}
function humanizeState(state) {
  switch (state) {
    case "submitted":
      return "Submitted";
    case "in_progress":
      return "In progress";
    case "waiting_on_customer":
      return "Waiting on you";
    case "resolved":
      return "Resolved";
    case "closed":
      return "Closed";
    default:
      return state.replace(/_/g, " ");
  }
}
function stateClass(state) {
  switch (state) {
    case "resolved":
    case "closed":
      return "tw:bg-gray-100 tw:text-gray-600";
    case "waiting_on_customer":
      return "tw:bg-amber-50 tw:text-amber-700";
    case "in_progress":
      return "tw:bg-blue-50 tw:text-blue-700";
    default:
      return "";
  }
}
function isDefaultState(state) {
  return state !== "resolved" && state !== "closed" && state !== "waiting_on_customer" && state !== "in_progress";
}
const defaultStateStyle = {
  backgroundColor: "var(--bc-support-bg)",
  color: "var(--bc-support-text)"
};
export {
  SupportTicketsListPart
};
//# sourceMappingURL=SupportTicketsListPart.js.map
